var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-component'),_c('header-mobile'),_c('v-main',{staticClass:"app"},[_c('landing-area'),_c('about-us'),_c('the-charter'),_c('the-crew'),_c('the-boat'),_c('rates'),_c('guest-info'),_c('brands'),_c('contact'),_c('bottom-bar'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }